// extracted by mini-css-extract-plugin
export var boxTitle = "payload-module--box-title--ryiiX";
export var buttonWithLink = "payload-module--button-with-link--IP69N";
export var contactTitle = "payload-module--contact-title--W7JsE";
export var contactUsSection = "payload-module--contact-us-section--Ci1XI";
export var customButton = "payload-module--custom-button--OjkJo";
export var customStylesButton = "payload-module--custom-styles-button--UZgDt";
export var descriptionContainer = "payload-module--description-container--s6Qcl";
export var firstRow = "payload-module--first-row--RFcHH";
export var header = "payload-module--header--Bpf97";
export var imageContainer = "payload-module--image-container--lqq1M";
export var innerWrapper = "payload-module--inner-wrapper--YcXFd";
export var section = "payload-module--section--1aHK1";
export var singleBoxDescriptionStyles = "payload-module--single-box-description-styles--pWMe8";
export var trustedBySection = "payload-module--trusted-by-section--AMrHn";